/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentsListListQueryResponse } from "../models/GetFragmentsListList";

export function getGetFragmentsListListUrl() {
  const res = { method: 'GET', url: `/fragments` as const }
  return res
}

/**
 * @summary List fragments with poster, social upload statuses and external delivery status (sort, filter, limit, page)
 * {@link /fragments}
 */
export async function getFragmentsListList(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFragmentsListListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetFragmentsListListUrl().url.toString(), ... requestConfig })
  return res.data
}